import React from 'react';
import PropTypes from 'prop-types';

const Confederation = props => {

    const { name, slug, urlAssets } = props;

    return (
        <section className={`d-flex align-items-center justify-content-start mt-0 mb-3 p-2 ${slug}`}>
            <article>
                <img src={`${urlAssets}/img/confederaciones/${slug}.png`} alt={name}/>
            </article>
            <article className="ms-2">
                <h2 className="my-0 text-white confederation-name">{name}</h2>
            </article>
        </section>
    )
}

export default Confederation;

Confederation.propTypes = {
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired
}